<script>
export default {
  name: "YieldRails",
  template: "#app-html",
  components: {
    SignupSigninView: () => import("../views/users/SignupSignin.vue"),
    ResetPasswordView: () => import("../views/users/ResetPassword.vue"),

    RestaurantSignup: () => import("../views/restaurants/Signup.vue"),

    ReviewFirstStepView: () => import("../views/reviews/firstStep.vue"),
    ReviewSecondStepView: () => import("../views/reviews/secondStep.vue"),
    ReviewNewAccountView: () => import("../views/reviews/newAccount.vue"),
    ReviewLandingPageView: () => import("../views/reviews/landingPage.vue"),
    ReviewShowPageView: () => import("../views/reviews/show.vue"),
    ReviewIndexPageView: () => import("../views/reviews/index.vue"),

    ReservationQuickEditView: () =>
      import("../views/reservations/quickEdit.vue"),

    // Blogger Reviews
    BloggersReviewsView: () => import("../views/bloggers/Reviews.vue"),
    BloggersProfileView: () => import("../views/bloggers/Profile.vue"),
    BloggersReviewsShowView: () => import("../views/bloggers/reviews/Show.vue"),

  },
  mounted() {
    setTimeout(() => {
      this.$jq("body").css("visibility", "visible");
    }, 1000);
  }
};
</script>
